import { render, staticRenderFns } from "./SelectService.vue?vue&type=template&id=5fc9dd68&"
import script from "./SelectService.vue?vue&type=script&lang=js&"
export * from "./SelectService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports